/** Minimum free bytes required before saving firma/foto blobs. */
export const STORAGE_MEDIA_RESERVE_BYTES = 50 * 1024 * 1024;

export const STORAGE_QUOTA_SESSION_BLOCK_MSG =
  'No hay espacio suficiente en el dispositivo para guardar la firma o la foto. Exporte registros en Observabilidad o libere espacio e intente de nuevo.';

export type StorageEstimate = {
  quotaBytes: number | null;
  usageBytes: number | null;
};

/** Session flag when IDB already hit QuotaExceeded (estimate() often missing on WebView). */
let sessionQuotaExceeded = false;

export function noteLocalStorageQuotaExceeded(): void {
  sessionQuotaExceeded = true;
}

export function clearLocalStorageQuotaExceededFlag(): void {
  sessionQuotaExceeded = false;
}

export function isLocalStorageQuotaExceededThisSession(): boolean {
  return sessionQuotaExceeded;
}

export async function readBrowserStorageEstimate(): Promise<StorageEstimate> {
  try {
    const estimate = await globalThis.navigator?.storage?.estimate?.();
    const quotaBytes =
      typeof estimate?.quota === 'number' && Number.isFinite(estimate.quota) ? estimate.quota : null;
    const usageBytes =
      typeof estimate?.usage === 'number' && Number.isFinite(estimate.usage) ? estimate.usage : null;
    return { quotaBytes, usageBytes };
  } catch {
    return { quotaBytes: null, usageBytes: null };
  }
}

/** Throws when estimate shows insufficient headroom, or session already saw QuotaExceeded. */
export async function assertLocalStorageHeadroomForMedia(
  reserveBytes = STORAGE_MEDIA_RESERVE_BYTES,
): Promise<void> {
  if (sessionQuotaExceeded) {
    throw new Error(STORAGE_QUOTA_SESSION_BLOCK_MSG);
  }
  const { quotaBytes, usageBytes } = await readBrowserStorageEstimate();
  if (quotaBytes == null || usageBytes == null) return;
  const freeBytes = quotaBytes - usageBytes;
  if (freeBytes < reserveBytes) {
    throw new Error(STORAGE_QUOTA_SESSION_BLOCK_MSG);
  }
}

